
import { Component, Vue, Watch } from 'vue-property-decorator'
import { apiShopLists } from '@/api/shop'
import { apiIndustryAdd,apiIndustryEdit,apiIndustryDetail } from '@/api/IndustryRequests'

import { debounce } from '@/utils/util'
import MaterialSelect from "@/components/material-select/index.vue";
@Component({
  components: {
    MaterialSelect,
  }
})
export default class ListsDetail extends Vue {
  /** S Data **/

  identity: number | null = null; // 当前编辑用户的身份ID

  setMealData: any = []
  shopData: any[] = []
  // 添加行业求购表单数据
  form: any = {
    sid: '', // 商城列表
    goods:"",//累计商品
    cumulative:"",//累计求购
    buyer:"",//求购人
    tel:"",//联系电话
    content:"",//求购内容
    type:0
  };

  // 表单校验
  rules = {
    sid: [{ required: true, message: '请选择商城列表', trigger: ['blur', 'change']}],
    goods: [
      { required: true, message: '请输入累计商品', trigger: 'blur' }
    ],
    cumulative: [
      { required: true, message: '请输入累计求购', trigger: 'blur' },
    ],
    buyer: [
      { required: true, message: '请输入求购人', trigger: 'blur' },
     
    ],
    tel: [{ required: true, message: '请输入联系电话', trigger: ['blur', 'change'] }],
    content: [{ required: true, message: '请输入求购内容', trigger: ['blur', 'change'] }]
  };


  // 点击表单提交
  onSubmit(formName: string) {
    // 验证表单格式是否正确
    const refs = this.$refs[formName] as HTMLFormElement
    refs.validate((valid: boolean): any => {
      if (!valid) return
      this.form.type = 0;
      if (!this.identity) {
        this.handleShopAdd()
      } else {
        this.handleShopEdit()
      }
    })
  }

  // 添加域名输入框
  addDomain() {
    this.form.domain_alias_list.push('')
  }

  // 移除域名输入框
  removeDomain(index: number) {
    if (this.form.domain_alias_list.length > 1) {
      this.form.domain_alias_list.splice(index, 1)
    }
  }

  // 添加行业求购
  async handleShopAdd(): Promise<void> {
    await apiIndustryAdd({ ...this.form })
    setTimeout(() => this.$router.go(-1), 500)
  }

  // 编辑行业求购
  async handleShopEdit(): Promise<void> {
    await apiIndustryEdit({ ...this.form, id: this.identity })
    setTimeout(() => this.$router.go(-1), 500)
  }
  //获取商场列表数据
  async getShopListsFn(): Promise<void>{
    const res: any = await apiShopLists({
       page_no: 1,
       page_size: 100,
    })
    this.shopData = res.lists;
  }   
  // 获取详情
  async getShopDetailFunc(): Promise<void> {
    const res: any = await apiIndustryDetail({
      id: this.identity as number,
      type:0
    })
    
    // 将 exConfig 数据回显到表单中
    if (res.exConfig && Array.isArray(res.exConfig)) {
      this.form.exConfig = res.exConfig.map((item: any) => {
        // 如果 ex 中有对应的数据，则使用 ex 中的数据作为默认值
        if (res.ex && res.ex[item.key]) {
          return {
            ...item,
            value: res.ex[item.key]
          };
        }
        return item;
      });
    } else {
      
    }
    Object.keys(res).map((key) => {
      this.$set(this.form, key, res[key])
    })
  }


  created() {
    const query: any = this.$route.query

    // 编辑模式：初始化数据
    this.identity = +query.id
    if (+query.id) {
      this.getShopDetailFunc()
    }
    // 获取商城列表是数据
    this.getShopListsFn()
    this.onSubmit = debounce(this.onSubmit, 2000)
  
  }
  /** E Life Cycle **/
}
